"use strict";const s=require("@mui/material"),t=()=>s.useMediaQuery(e=>e.breakpoints.up("md"));module.exports=t;
